import React from "react";
import classNames from "classnames/bind";

import { LoaderIcon } from "src/assets/icons";

import styles from "./Loader.module.scss";
const cx = classNames.bind(styles);

const Loader = ({ fullHeight }) => {
  return (
    <div className={cx("loader-root", { "h-full": fullHeight })}>
      <LoaderIcon />
    </div>
  );
};

export default Loader;
